import { registerLicense } from "@syncfusion/ej2-base";

import { JobPipelineTableOrKanban } from "@/components";

import { useGetCandidacies, useGetJob } from "@/hooks/queries";
import { env } from "@/lib/env";

// TODO: Is there a better place for this?
const syncfusionLicenseKey = env.getSyncfusionKey();
registerLicense(syncfusionLicenseKey);

export const JobPipeline = ({ className }: { className?: string }) => {
  const {
    data: candidaciesWithProfiles,
    status: candidaciesWithProfilesStatus,
  } = useGetCandidacies();
  const { data: job, status: jobStatus } = useGetJob();

  if (candidaciesWithProfilesStatus === "pending" || jobStatus === "pending") {
    // TODO: Loading state.
    return null;
  } else if (
    candidaciesWithProfilesStatus === "error" ||
    jobStatus === "error"
  ) {
    // TODO: Error state.
    return null;
  }

  return (
    <div className={className}>
      <JobPipelineTableOrKanban
        candidaciesWithProfiles={candidaciesWithProfiles}
        job={job}
        key={job.id} // TODO: Is this the best way to handle this?
      />
    </div>
  );
};
